import { render, staticRenderFns } from "./Gradients.vue?vue&type=template&id=1e202a64&scoped=true&"
import script from "./Gradients.vue?vue&type=script&lang=js&"
export * from "./Gradients.vue?vue&type=script&lang=js&"
import style0 from "./Gradients.vue?vue&type=style&index=0&id=1e202a64&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e202a64",
  null
  
)

export default component.exports